import * as React from 'react'
import styles from './style.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import _, { isEmpty } from "lodash";
import { ReactComponent as LOCATION } from '../../../../../static/IconProvider/location.svg'
import { ReactComponent as ADDRESS_BOOK } from '../../../../../static/IconProvider/address_book.svg'
import { ReactComponent as INFO_CIRCLE } from '../../../../../static/IconProvider/info-circle.svg'
import search_not_found_gray from '../../../../../static/search_not_found_gray.svg'

import { CLOSE_DARK, HISTORY, PICKUP } from '../../../../../static';
import { ChooseoOnMapimg, RemoveAddressBookFromList, Set_latlng, Set_Map_Geocoding, Set_Pickup_address, Set_Pickup_Inputs, Set_SearchAutoCompleteLoading, SetopenAddressBookInNewOrder } from '../../../../../Redux/actions/actionNames';
import { getCenterMap, setCenterMap } from '../../../../../helper/module';
import { Api_Add_Addressbook_AGW, Api_Delete_Addressbook_AGW, Api_Get_Addressbook_list_AGW, Api_map_geocoding_reverse_AGW, Api_PlaceIdDetails_AGW, Api_SearchAutoComplete_AGW } from '../../../../../helper/api/ApiGateway';
import SearchList from '../../../../../design-system/lib/SearchList';
import Typography from '../../../../../design-system/lib/Typography';
import IconProvider from '../../../../../design-system/lib/IconProvider';
import { get_customerPannel_type, Get_Permisssion } from '../../../../../helper/UserData/userdate';
import RecentAddressItem from './components/recentAddressItem';
import AddressItem from './components/addressItem';
import Button from '../../../../../design-system/lib/Button';
import PickupInfoNewOrder from './components/info';
import IconProviderSvgModifier from '../../../../../design-system/lib/IconProviderSvgModifier';
import Schedule from '../Schedule/Schedule';
import service_point from '../../../../../static/IconProvider/service_point.svg';
import service_point_color from '../../../../../static/IconProvider/service_point_color.svg';
import danger from '../../../../../static/IconProvider/danger.svg';
import location_gray from '../../../../../static/IconProvider/location_gray.svg';

import ServicePoint_addressItem from './components/servicePoint_addressItem';
import { ServicesApi } from '../../../../../service/api/service';
 
import { ReactComponent as BookmarkInActive } from '../../../../../static/IconProvider/bookmarkInActive.svg'
import { ReactComponent as Bookmarkactive } from '../../../../../static/IconProvider/Bookmarkactive.svg'
import { SucceessFul_i18 } from '../../../../../helper/Notification/sendNotification';
import Modal from '../../../../../design-system/lib/Modal';
import Input from '../../../../../design-system/lib/Input';
import { PERSON, WARNING  } from '../../../../../static';

function PickupNewOrder({handleCollapse}) {
  const [id, setid] = React.useState("pickup");
  const [sessionToken, setSessionToken] = React.useState(null);

    const addressDetail = useSelector((state) => state.NewOrder.newOrder.pickup.addressDetail)
    const block = useSelector((state) => state.NewOrder.newOrder.pickup.block)
    const floor = useSelector((state) => state.NewOrder.newOrder.pickup.floor)
    const unit = useSelector((state) => state.NewOrder.newOrder.pickup.unit)
    const email = useSelector((state) => state.NewOrder.newOrder.pickup.email)
 
    const noteForDriver = useSelector((state) => state.NewOrder.newOrder.pickup.noteForDriver)

  const dispatch = useDispatch();
   const { t } = useTranslation();
  // const auto = useSelector((state) => state.NewOrder.newOrder.pickup.driver.auto)
  // const customerId = useSelector((state) => state.NewOrder.newOrder.customer.id)
  // const BusinessId = useSelector((state) => state.NewOrder.newOrder.customer.BusinessId)
   const mapRef = useSelector((state) => state.Map.mapRef)
  const centerMap = useSelector((state) => state.Map.center)
  const name = useSelector((state) => state.NewOrder.newOrder.pickup.name)

   const address = useSelector((state) => state.NewOrder.newOrder.pickup.address)
    const adresss_loc = useSelector((state) => state.NewOrder.newOrder.pickup.adresss_loc)
   const emailg = useSelector((state) => state.NewOrder.newOrder.pickup.email)
  const senderFullName = useSelector((state) => state.NewOrder.newOrder.pickup.senderFullName)
   const senderPhoneNumber = useSelector((state) => state.NewOrder.newOrder.pickup.senderPhoneNumber)
   const activePickupDropOff = useSelector((state) => state.NewOrder.newOrder.activePickupDropOff)
   const suggestListPickUpDropOffLoading = useSelector((state) => state.NewOrder.newOrder.suggestListPickUpDropOffLoading)
   const suggestPickUpDropOffListData = useSelector((state) => state.NewOrder.newOrder.suggestPickUpDropOffListData)
   const pickupDropOffType = useSelector((state) => state.NewOrder.newOrder.map_Data.pickupDropOff.type)
  const ActivescheduleSetting = useSelector((state) => state.NewOrder.newOrder.service.activeVehicleType ? state.NewOrder.newOrder.service.activeVehicleType.scheduleSetting.isActive : false)
  const serviceactiveVehicleType = useSelector((state) => state.NewOrder.newOrder.service.activeVehicleType)
  const scheduleDateBefore = useSelector((state) => state.NewOrder.newOrder.pickup.scheduleDateBefore)
  const scheduleDateAfter = useSelector((state) => state.NewOrder.newOrder.pickup.scheduleDateAfter)
  const delayedQuerySP = React.useCallback(_.debounce((...pr) => HandleChangeSP(...pr), 500), []);
  const Addressbooklist = useSelector((state) => state.Addressbook.list)
  const [modalAddActive, setModalAddActive] = React.useState(false);
  const [modalDelActive, setModalDelActive] = React.useState(false);
   const activeVehicleType = useSelector((state) => state.NewOrder.newOrder.service.activeVehicleType)
  const openAddressBook = useSelector((state) => state.Addressbook.openAddressBookInNewOrder)
  // const orderTypeActive = useSelector((state) => state.NewOrder.newOrder.orderTypeActive)
//  const recentAddress = useSelector((state) => state.NewOrder.newOrder.customer.recentAddreess)
  const addressBookSource = useSelector((state) => state.Addressbook.openAddressBookInNewOrder
  ? state.Addressbook.sourceOfAddressBookInNewOrder
    ? state.Addressbook.sourceOfAddressBookInNewOrder.type == "pickup"
    : false
  : false)

  const [modalAddData, setModalAddData] = React.useState({title: null , code : null});

  const pickupLocationType = useSelector((state) => state.NewOrder.newOrder.deliveryMethod?.pickupLocationType)
  const deliveryMethod = useSelector((state) => state.NewOrder.newOrder.deliveryMethod)
  // const pickupLocationType = useSelector((state) => state.NewOrder.newOrder.deliveryMethod?.dropoffLocationType)

  const [servicepoints, setServicepoints] = React.useState([]);
  const [servicepointsIsLoading, setServicepointsIsLoading] = React.useState(false);



  React.useEffect(() => {
    if (pickupLocationType != "address" && deliveryMethod?.id) {
      (async () => {
        setServicepointsIsLoading(true)
        const Services = new ServicesApi();
        const ServicePoints = await Services.ServicePoints({
          deliveryMethodId: deliveryMethod?.id,
          locationType: "pickup"
        })
        console.log("ServicePoints5 ", ServicePoints)
        setServicepoints(ServicePoints)
        setServicepointsIsLoading(false)

      })();
    }
  }, [pickupLocationType, deliveryMethod])


  const GetserachListItemOnclickSP = React.useCallback((item) => {

    dispatch(
      Set_latlng({ lng: item.coordinates.lng, lat: item.coordinates.lat })
    );

    dispatch(
      Set_Pickup_address({
        ...item,
        address: item.address,
        adresss_loc: { lng: item.coordinates.lng, lat: item.coordinates.lat },
        id: item.id,
        name: item.name
      })
    );
    mapSetView({
      lng: item.coordinates.lng, lat: item.coordinates.lat
    });


  }, [  address, suggestPickUpDropOffListData]);


  const handleSearchSPInput = React.useCallback((e, name) => {


    if (e?.target?.ignore) {
      return null
    }

    if (name === "address" || e?.target.id === "address") {

      if (e && e?.target.value != "") {
        e?.target?.value.length > 2 && delayedQuerySP(e?.target.value , deliveryMethod)

        if (e?.target?.value.length == 0 && address?.length > 0) {
          delayedQuerySP(e?.target.value , deliveryMethod)
        }
      }

      if (e?.target?.value.length == 0) {
        delayedQuerySP("" , deliveryMethod)
      }

    }

    if (e) {
      dispatch(
        Set_Pickup_Inputs({
          name: name || e?.target.id,
          value: e?.target.value,
        })
      );
    }
  }, [deliveryMethod]);


  const HandleChangeSP = React.useCallback(async (value , fefefe) => {

            

      setServicepointsIsLoading(true)
      const Services = new ServicesApi();
      const ServicePoints = await Services.ServicePoints({
        deliveryMethodId: fefefe?.id,
        locationType: "pickup",
        search: value
      })
      setServicepoints(ServicePoints)
      setServicepointsIsLoading(false)

 
  }, [deliveryMethod]);


  //   ? state.Addressbook.sourceOfAddressBookInNewOrder
  //     ? state.Addressbook.sourceOfAddressBookInNewOrder.type == "pickup"
  //     : false
  //   : false)
  //   const auto_activeVehicleType = useSelector((state) => state.NewOrder.newOrder.pickup.driver.auto_driver.auto_activeVehicleType)
  //   const manual_activeVehicleType = useSelector((state) => state.NewOrder.newOrder.pickup.driver.manual_driver.manual_activeVehicleType)
  //   const driveroptions = useSelector((state) => state.NewOrder.newOrder.pickup.driver.options)

  // const auto_suggestListData = useSelector((state) => state.NewOrder.newOrder.driver.auto_driver.auto_suggestListData)
  // const pickup_manual_id = useSelector((state) => state.NewOrder.newOrder.pickup.driver.manual_driver.manual_id)


 

  // React.useEffect(() => {
  //   notThrottleHandleChange(String(address), sessionToken)
  // }, [localSearchIsActive])


  // const serachListData = React.useCallback(() => {

  //   if (_.isEmpty(address)) {
  //     if (_.isEmpty(customerId)) {
  //       return null //error customer
  //     } else {
  //       if (_.isEmpty(recentAddress)) {
  //         return null //error recentAddress
  //       } else {
  //         return recentAddress
  //       }
  //     }
  //   } else {
  //     if (_.isEmpty(suggestPickUpDropOffListData)) {
  //       return null //error suggestPickUpDropOffListData
  //     } else {
  //       return suggestPickUpDropOffListData
  //     }
  //   }


  // }, [recentAddress, customerId, address, suggestPickUpDropOffListData]);


  const emailValidate=(email)=> {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

    const handlePickUpInputs = React.useCallback((e, name) => {

      if(!e?.target){
        return
      }

    let center = getCenterMap(mapRef, centerMap);
    if (UserHavePermission()) {
      if (name === "address" || e.target.id === "address") {

        setSessionToken(sessionToken ? sessionToken : uuidv4())
        dispatch(
          Set_Pickup_address({
            adresss_loc: { lng: "", lat: "" },
            placeId: "",
          })
        );
        dispatch(Set_SearchAutoCompleteLoading(true));
        if (e.target.value != "") {
          e.target.value.length > 2 && Api_SearchAutoComplete_AGW(dispatch, {
            query: e.target.value,
            latitude: mapRef.current
              ? center.lat
              : center.lat,
            longitude: mapRef.current
              ? center.lng
              : center.lng,
            sessionToken: sessionToken

          });
        }
      }
      dispatch(
        Set_Pickup_Inputs({
          name: name || e.target.id,
          value: e.target.value,
        })
      );
    }
  },[mapRef, centerMap , sessionToken ,])
 
  const handleList = React.useCallback((item) => {
    if(!item){
      return 
    }

    if (item.coordinates) {
      dispatch(
        Set_Map_Geocoding({
          address: item.secondaryAddress
            ? item.address + " , " + item.secondaryAddress
            : item.address,
        })
      );

      dispatch(
        Set_Pickup_address({
          ...item,
          address: item.secondaryAddress
            ? item.address + " , " + item.secondaryAddress
            : item.address,
          adresss_loc: { lng: item.coordinates[0], lat: item.coordinates[1] },
        })
      );
      mapSetView({
        lng: item.coordinates[0],
        lat: item.coordinates[1],
      });

   
      setSessionToken(null)


    } else {

      setSessionToken(sessionToken ? sessionToken : uuidv4())

      Api_PlaceIdDetails_AGW(
        dispatch,
        { placeId: item.placeId, sessionToken: sessionToken },
        (res) => {
          mapSetView({ lng: res.coordinates[0], lat: res.coordinates[1] });
          dispatch(
            Set_Map_Geocoding({
              address: res.address,
            })
          );

          dispatch(
            Set_Pickup_address({
              ...item,
              address: res.address,
              adresss_loc: { lng: res.coordinates[0], lat: res.coordinates[1] },
            })
          );
          dispatch(
            Set_latlng({
              lng: res.coordinates[0],
              lat: res.coordinates[1],
            })
          );
        }
      );


    }

    if (activePickupDropOff.type != "pickup") {
      handleCollapse({
        type: "pickup",
        id: "pickup",
      });
    }

    dispatch(SetopenAddressBookInNewOrder(false, "", null, ""));

  },[])
 

  const mapSetView = React.useCallback((e) => {

    try {
      setCenterMap(mapRef, e)
      // mapRef.current.leafletElement.setView(e, 17);
    } catch (error) {
      dispatch(
        Set_latlng({
          lng: e.lng,
          lat: e.lat,
        })
      );
    }
  },[])
 

  const UserHavePermission = React.useCallback(() => {

    if (get_customerPannel_type() == "business") {
      if (Get_Permisssion()?.isDefaultPickupAddressEditable) {
        return true
      } else if (adresss_loc.lat == '') {
        return true
      } else {
        return false
      }


    } else {
      return true
    }

  },[adresss_loc])
 

   const GetSearchListError = React.useCallback(() => {


    if (pickupLocationType != "address") {
      if (_.isEmpty(address)) {
        if (!servicepoints || _.isEmpty(servicepoints)) {
          return {
            errorTitle: t("No service point available"),
            errorIcon: service_point,
          }
        } else {
          return null
        }
     } else if (!_.isEmpty(address)) {
      if ((!servicepointsIsLoading && (servicepoints.length === 0 || _.isEmpty(servicepoints)))) {
        return {
          errorDescription: t("NoResultfromLocalDatabaseD"),
          errorIcon: null,
        }
      }
  }
    }else {
          if ((!suggestListPickUpDropOffLoading &&
      suggestPickUpDropOffListData.length === 0 && !_.isEmpty(address)) || (!_.isEmpty(address) && !suggestListPickUpDropOffLoading && !suggestPickUpDropOffListData)) {
      return {
        errorDescription: t("NoResultfromLocalDatabaseD"),
        errorTitle: t("Noresultfound"),
        errorIcon: search_not_found_gray,
        errorActionTitle:t("Clearfield")
      }
    }
    }
   


  }, [ address, suggestPickUpDropOffListData, servicepoints , suggestListPickUpDropOffLoading , pickupLocationType , servicepointsIsLoading]);


  const GetserachListItem = React.useCallback(() => {

    return AddressItem

  }, [ address, suggestPickUpDropOffListData]);

  const serachListData = React.useCallback(() => {


    if (pickupLocationType != "address") {
      if (servicepoints && !_.isEmpty(servicepoints)) {
        return servicepoints
      } else {
        return null
      }
    }

   
      if (_.isEmpty(suggestPickUpDropOffListData)) {
        return null //error suggestPickUpDropOffListData
      } else {
        return suggestPickUpDropOffListData
      }


  }, [ address, suggestPickUpDropOffListData , servicepoints ,pickupLocationType]);



  const ChooseoOnMap = React.useCallback(() => {

    if (UserHavePermission()) {
      if (
        pickupDropOffType &&
        pickupDropOffType == "Pickup"
      ) {
        dispatch(
          ChooseoOnMapimg({
            showMap: false,
            pickupDropOff: {
              type: null,
              id: null,
            },
          })
        );
      } else {
        let center = getCenterMap(mapRef, centerMap);
        Api_map_geocoding_reverse_AGW(dispatch, {
          latitude: mapRef.current
            ? center.lat
            : center.lat,
          longitude: mapRef.current
            ? center.lng
            : center.lng,
        });

         dispatch(
          ChooseoOnMapimg({
            showMap: true,
            pickupDropOff: {
              type: "Pickup",
              id: null,
            },
          })
        );
      }
    }

}, [ pickupDropOffType]);


const pickupRequiredCheck = React.useCallback(() => {
  if (activeVehicleType) {
    let name = false, email = false, phone = false;

    if (activeVehicleType.setting.isPickupAddressNameRequired) {
      if (senderFullName && String(senderFullName).trim().length > 0) {
        name = true
      } else {
        name = false
      }
    } else {
      name = true
    }

    if (activeVehicleType.setting.isPickupAddressPhoneRequired) {
      if (senderPhoneNumber && String(senderPhoneNumber).trim().length > 0) {
        phone = true
      } else {
        phone = false
      }
    } else {
      phone = true
    }


    if (activeVehicleType.setting.isPickupAddressEmailRequired) {
      if (emailg && String(emailg).length > 0 && emailValidate(String(emailg))) {
        email = true
      } else {
        email = false
      }
    } else {
      email = true
    }



    return (name && phone && email);

  } else {
    return false
  }

}, [activeVehicleType , emailg , senderPhoneNumber , senderFullName]);


const resetPickup = React.useCallback(() => {
  dispatch(
    Set_Pickup_address({
      address: "",
      adresss_loc: { lng: "", lat: "" },
      placeId: "",
    })
  );

}, [ ]);


const openAddressbook = React.useCallback(() => {
  if (UserHavePermission()) {
    if (openAddressBook && addressBookSource) {
      dispatch(SetopenAddressBookInNewOrder(false, "", null, ""));
    } else {
      dispatch(
        SetopenAddressBookInNewOrder(true, "pickup", null, "AddressbookPickup")
      );
    }
  }

}, [ openAddressBook , addressBookSource]);


const handleShowInfo = React.useCallback(() => {

  const isOpen = activePickupDropOff.type === "pickup"
  
  const myEvent = new CustomEvent("closeSliders",{ detail:null});
  document.dispatchEvent(myEvent);


  if(!isOpen){
    handleCollapse({
      type: "pickup",
      id: "pickup",
    });
  }else{
       setTimeout(() => {
   handleCollapse({
    type: null,
    id: ""
   });
 }, 100);
  }

}, [activePickupDropOff]);



  React.useEffect(() => {
    const isOpen = activePickupDropOff.type === "pickup"

    const myEvent = new CustomEvent("closeSliders", { detail: null });
    document.dispatchEvent(myEvent);

    if (adresss_loc.lat != '') {
      if (!isOpen) {
        handleCollapse({
          type: "pickup",
          id: "pickup",
        });
      }
    }
  }, [adresss_loc])



  React.useEffect(() => {
  
    if(pickupLocationType != "address" && isEmpty(name)  && !isEmpty(String(adresss_loc.lat))){
      dispatch(
        Set_Pickup_address({
          address: "",
          adresss_loc: { lng: "", lat: "" },
          placeId: "",
          id:null,
          name:null
        })
      );

    }


    if(pickupLocationType == "address" && !isEmpty(name)  && !isEmpty(String(adresss_loc.lat))){
      dispatch(
        Set_Pickup_address({
          address: "",
          adresss_loc: { lng: "", lat: "" },
          placeId: "",
          id:null,
          name:null
        })
      );
    }
 
   }, [pickupLocationType ,  name , id])



    const detectOrderType = React.useCallback(() => {
  
      if (serviceactiveVehicleType && serviceactiveVehicleType.orderTypes?.indexOf("PickupDelivery") > -1) {
        return "PickupDelivery"
      } else {
        return "Ondemand"
      }
  
    },[serviceactiveVehicleType])


      const checkInputFilledByAB = React.useCallback(() => {
        let status = false;
          Addressbooklist.forEach((element) => {
            if (element.address == address) {
              status = true;
            }
          });
          return status;
       
      }, [Addressbooklist,address ]);
    
  const getAddressbookId = React.useCallback(() => {
    let status = null;

    console.log("dwdfe343 ", Addressbooklist , address)
      Addressbooklist.forEach((element) => {
        if (element.address == address) {
          status = element.id;
        }
      });
      return status;
   
  }, [Addressbooklist,address ]);


        const RemoveAddressBook = React.useCallback(() => {
          setModalDelActive(false)
          let xxx = getAddressbookId()
          Api_Delete_Addressbook_AGW(
            dispatch,
            xxx,
            (call) => {
              call &&
                dispatch(
                  RemoveAddressBookFromList(xxx)
                );
            }
          );
        }, [Addressbooklist,address ]);
      

        const handleNewBookmark = React.useCallback(() => {
      
              Api_Add_Addressbook_AGW(dispatch, {
                "title": modalAddData.title,
                "address": address,
                // addressDetail : addressDetail ,
                  "coordinates": [
                      adresss_loc.lng, adresss_loc.lat
                  ], 
                  "buildingBlock": block,
                  "floor": floor,
                  "fullName": senderFullName,
                  "phone": senderPhoneNumber,
                  "placeId": "",
                  "room": unit,
                  "code": modalAddData.code ? modalAddData.code  : "" ,
                  email:email ,
                  description:noteForDriver ,
              },(call)=>{
                if(call.loading){
                  setModalAddActive(false)
                }else {
                  setModalAddActive(false)
                  setModalAddData({title: null , code : null})
                  if(call.ok){
                    SucceessFul_i18(
                      "Createdsuccessfully",
                      "networkError",
                      "close",
                      () => {
                        dispatch({
                          type: "removeNetworkErrorSnack",
                          key: "networkError",
                        });
                      },
                      new Date().getTime() + Math.random()
                    );
                    Api_Get_Addressbook_list_AGW(dispatch, {page:1 , perpage:20 , searchRegex:""}, false);
        
                  }else{
                    
                  }
                }
              });
        
      
          //    setModalAddActive(false)
      
      
        },[senderPhoneNumber , addressDetail , address, adresss_loc,block ,floor , unit,senderFullName,noteForDriver ,email ,modalAddData ])
      
      

  if (isEmpty(String(adresss_loc.lat))) {
    return <div className={styles.PickupOnlyNewOrderContainer}>

      <div className={styles.PickupOnlyNewOrderContainerFirstRow}>
        <IconProvider Icon={PICKUP} size='16' />
        <Typography text={t("Collection from")} weight='Body_Middle_Bold' />
       {address.length == 0 && <span className={styles.starRequired}>*</span>}
       {ActivescheduleSetting && <Schedule orderType={detectOrderType()}
                  scheduleDateBefore={scheduleDateBefore}
                  scheduleDateAfter={scheduleDateAfter}
                  id={id} 
                  type={"pickup"}
                />}
      </div>

      <div className={styles.PickupOnlyNewOrderContainerSecondRow}>
        <SearchList  DefaultListPreview={(isEmpty(address) && pickupLocationType != "address" && servicepoints && servicepoints.length > 0) && <div className={styles.DefaultListPreview}>
          <Typography weight='Body_Tiny_Medium' text={t("All Service points")} style={{ marginTop: "16px", marginBottom: "4px", width: "100%", width: "calc(100% - 24px)", marginInlineStart: "12px", marginInlineEnd: "12px", marginTop: "8px", color: "#484848" }} />
          <div className={styles.DefaultListItemsContainerPreview}>
            {servicepoints.map((item) => {
              return <ServicePoint_addressItem data={item} onclick={() => { GetserachListItemOnclickSP(item) }} />
            })}
          </div>

        </div>} 
      inputIcon={<img src={pickupLocationType == "address" ? location_gray : service_point} />}
      onChange={pickupLocationType == "address" ? (e) => handlePickUpInputs(e, "address") : (e) => handleSearchSPInput(e, "address")}
        style={{ zIndex: "2" }} value={address} 
        placeHolder={pickupLocationType == "address" ? t("Search and select address") : t("Search and select service point")}
        isloading={pickupLocationType == "address" ? suggestListPickUpDropOffLoading : servicepointsIsLoading}
        listItemOnclick={pickupLocationType == "address" ? handleList  : GetserachListItemOnclickSP}

        error={GetSearchListError()} 
        errorDescription={GetSearchListError()?.errorDescription} 
        errorTitle={GetSearchListError()?.errorTitle} 
        errorIcon={GetSearchListError()?.errorIcon}
         errorActionOnClick={(e) => handlePickUpInputs({target:{value:""}}, "address")} 
         errorActionTitle={GetSearchListError()?.errorActionTitle}
           ListItemChildren={pickupLocationType == "address" ? GetserachListItem() : ServicePoint_addressItem}

          list={serachListData()} inputInnerChildren={null}
        />
       {pickupLocationType == "address" && <Button iconComponentChildren={<IconProviderSvgModifier Icon={LOCATION} size='16' />} size='Medium' type='Secondary' style={{ marginInlineEnd: "7px" }} onClick={ChooseoOnMap} isActive={pickupDropOffType == "Pickup"} />}
       {pickupLocationType == "address" && <Button iconComponentChildren={<IconProviderSvgModifier Icon={ADDRESS_BOOK} size='16' />}  size='Medium' type='Secondary'  onClick={openAddressbook} isActive={addressBookSource} />}
      </div>

      {address.length > 0  && <Typography text={t("Please select address from search results")} weight='Body_Small_Regular' style={{
          width: "345px", overflow: 'hidden',
          textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: "1"  ,marginTop:"-6px"  
        }} textColor='Red' />}
    </div>
  }

  return (
    <>

      <div className={styles.PickupOnlyNewOrderSelectedContainer}>
      <div className={styles.PickupOnlyNewOrderContainerFirstRow} style={{width:"100%"}}>
        <IconProvider Icon={PICKUP} size='16' />
        <Typography text={t("Collection from")} weight='Body_Middle_Bold' style={{marginInlineEnd:"auto"}} />

         {ActivescheduleSetting && <Schedule orderType={detectOrderType()}
                  scheduleDateBefore={scheduleDateBefore}
                  scheduleDateAfter={scheduleDateAfter}
                  id={id} 
                  type={"pickup"}
                />}
       {/* {!pickupRequiredCheck() && <span className={styles.starRequired}>*</span>} */}
      </div>
        <div className={styles.PickupOnlyNewOrderSelectedContainerFrow} style={{ marginTop: (name && name.length > 0) && "4px" }}>
        {(name && name.length > 0) && <img src={service_point} />}

        <div style={{ display: "flex", flexDirection: "column", gap: "0px", flex: "1" }}>
            {(name && name.length > 0) && <Typography text={name} weight='Body_Middle_Regular' style={{
              width: "293px", overflow: 'hidden',
              textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: "1", lineHeight: "15px"
            }} />}
            <Typography text={address} weight={(name && name.length > 0) ? "Body_Tiny_Regular" : 'Body_Middle_Regular'} style={{
              width: "293px", overflow: 'hidden',
              textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: "1", lineHeight: "15px" , color : (name && name.length > 0) ? "rgba(128, 128, 128, 1)" : 'rgba(72, 72, 72, 1)'
          }} />
          </div>

          {checkInputFilledByAB() ?
          <Button disabled={!UserHavePermission()} onClick={() => { setModalDelActive(true) }} size='Medium' type='Secondary' iconComponentChildren={<IconProviderSvgModifier Icon={Bookmarkactive} size='16' />} >  </Button>
          : <Button onClick={() => { setModalAddActive(true) }} size='Medium' type='Secondary' iconComponentChildren={<IconProviderSvgModifier Icon={BookmarkInActive} size='16' />} >  </Button>
        }
          {/* <Button  iconComponentChildren={<IconProviderSvgModifier Icon={INFO_CIRCLE} size='16' />}  size='Medium' type='Secondary' badge={( !pickupRequiredCheck() ) && true} onClick={handleShowInfo} isActive={activePickupDropOff.type === "pickup"} /> */}
          <Button size={'Small'} icon={CLOSE_DARK} type='Secondary' style={{ marginInlineStart: "4px", backgroundColor: "transparent", padding: "8px 8px" }} onClick={resetPickup} /> 

        </div>


       {/* {(  !pickupRequiredCheck() ) && <Typography text={t("Complete * Feileds")} weight='Body_Small_Regular' style={{
          width: "345px", overflow: 'hidden',
          textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: "1"
        }} textColor='Red' />} */}

<PickupInfoNewOrder handleShowInfo={handleShowInfo} pickupRequiredCheck={pickupRequiredCheck()}/>
{ modalAddActive && <Modal  onclose={()=>{setModalAddActive(false)}} 
      
      body={<div className={styles.addAddressbookContainer}>
          <div className={styles.addAddressbookinnerContainer} style={{paddingBottom : "16px" ,borderBottom:"1px solid #F4F4F7"}}> 
                <Input title={t("title")} isRequired={true} isRequiredText='*'  type={"text"} placeHolder={t('ExHome')} value={modalAddData.title} onChange={(e)=>{setModalAddData({title : e.target.value , code : modalAddData.code})}}/>
                <Input title={t('Code')}  type={"text"} placeHolder={t('Ex123')} value={modalAddData.code}  onChange={(e)=>{setModalAddData({title : modalAddData.title , code : e.target.value})}}/>

          </div>
          <div className={styles.addAddressbookinnerContainer} style={{paddingTop:"16px" }}> 
              
              <div className={styles.addAddressnamephoneContainer}>
                <IconProvider Icon={PICKUP} size='16' />
                <div className={styles.addAddressnamephoneInnerContainer}>
                  <Typography weight='Body_Middle_Medium' text={address} style={{lineHeight : "16.71px"}} />
                  <Typography weight='Body_Tiny_Regular' text={isEmpty(addressDetail) ? "-" : addressDetail} />
                </div>
              </div>

      
             {(!isEmpty(senderFullName) || !isEmpty(senderPhoneNumber)) && <div className={styles.addAddressnamephoneContainer} style={{borderTop:"1px solid rgb(244, 244, 247)",paddingTop:"12px"}}>
                <IconProvider Icon={PERSON} size='16' style={{alignSelf :"center"}} />
                <div className={styles.addAddressnamephoneInnerContainer}>
                  <Typography weight='Body_Middle_Medium' text={isEmpty(senderFullName) ? "--" : senderFullName} style={{lineHeight : "17.3px"}} />
                  <Typography weight='Body_Tiny_Regular' text={isEmpty(senderPhoneNumber) ? "-" : senderPhoneNumber}  />
                </div>
               {!isEmpty(email) && <Typography style={{alignSelf :"end" , marginInlineStart :"auto"}} weight='Subtitle_Tiny_Regular' text={email}  />}

              </div>}

          </div>
      </div>} ConfirmationDisabled={isEmpty(modalAddData.title)} size='Large' CancelText={t("Cancel")} CancelOnClick={()=>{setModalAddActive(false)}} ConfirmationOnClick={handleNewBookmark} ConfirmationText={t("Add")} icon={WARNING} title={t('Addtoaddressbook')} description='This address with entered details will be address to your address book.'  />  }
      { modalDelActive && <Modal size='Small' ConfirmationStyle={{color:"white",backgroundColor:"red"}} CancelText={t("Cancel")} CancelOnClick={()=>{setModalDelActive(false)}} ConfirmationOnClick={RemoveAddressBook} ConfirmationText={t("YesRemove")} icon={WARNING} title={t('Removefromaddressbook')} description={t("RemovefromaddressbookDesc")}  />}

      </div> 

      {/* {activePickupDropOff.type === "pickup" && <PickupInfoNewOrder handleShowInfo={handleShowInfo} />} */}
    </>

  )
}

export default PickupNewOrder